// extracted by mini-css-extract-plugin
export var box = "SliderButton-module--box--bfff1";
export var box_md = "SliderButton-module--box_md--a4699";
export var box_xmd = "SliderButton-module--box_xmd--0f790";
export var box_flex = "SliderButton-module--box_flex--a4754";
export var box_lg = "SliderButton-module--box_lg--8896b";
export var box_sm = "SliderButton-module--box_sm--c6330";
export var box_outer = "SliderButton-module--box_outer--9ee50";
export var box_whiteBg = "SliderButton-module--box_white-bg--bb339";
export var box_noMarginBottom = "SliderButton-module--box_no-margin-bottom--0537d";
export var box_noPadding = "SliderButton-module--box_no-padding--e18be";
export var box_outerGray = "SliderButton-module--box_outer-gray--47f10";
export var box_dark = "SliderButton-module--box_dark--47501";
export var box_zIndex = "SliderButton-module--box_z-index--47fe2";
export var box_zIndex6 = "SliderButton-module--box_z-index-6--319b0";
export var box_eventsWithLine = "SliderButton-module--box_events-with-line--6f32c";
export var box_featuresAo = "SliderButton-module--box_features-ao--0751c";
export var box_verticalPaddings = "SliderButton-module--box_vertical-paddings--b958e";
export var clearP = "SliderButton-module--clearP--77fbe";
export var clearP_vc = "SliderButton-module--clearP_vc--5c4a9";
export var wrapper = "SliderButton-module--wrapper--fc863";
export var arrowIcon = "SliderButton-module--arrowIcon--57a1b";
export var white = "SliderButton-module--white--28f6a";
export var fadeInAnimation = "SliderButton-module--fadeInAnimation--8f3ad";
export var placeHolderShimmer = "SliderButton-module--placeHolderShimmer--db6c9";